var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 100,
    viewBox: "0 0 99 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.480469,
    width: 98.0392,
    height: 100,
    rx: 49.0196,
    fill: "#68E1FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4805 26C62.7105 26 73.4805 36.77 73.4805 50C73.4805 63.23 62.7105 74 49.4805 74C36.2505 74 25.4805 63.23 25.4805 50C25.4805 36.77 36.2505 26 49.4805 26ZM49.4805 20C32.9205 20 19.4805 33.44 19.4805 50C19.4805 66.56 32.9205 80 49.4805 80C66.0405 80 79.4805 66.56 79.4805 50C79.4805 33.44 66.0405 20 49.4805 20ZM52.4805 50V38H46.4805V50H37.4805L49.4805 62L61.4805 50H52.4805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.68ecfa72b052c07a4a12edcb68c02380.svg";
export { ForwardRef as ReactComponent };